<template>
	<div class="document page-break">
		<p style="text-align: right;">
			Приложение № {{ index }}
			<br>к Договору № {{ $root.contract.number }} от {{ $root.contract.date }}
		</p>
		<h4 class="h">Спецификация № {{ index }}</h4>
		<div class="spcf_table">
			<table class="table table-bordered" cellpadding="6">
				<tbody>
					<tr>
						<th>№ п.п.</th>
						<th>Наименование</th>
						<th>Единица измерения</th>
						<th>Количество лицензий</th>
						<th>Цена, руб.</th>
						<td><b>Сумма(без НДС)</b><br></td>
					</tr>
					<tr>
						<td>1</td>
						<td>Программный комплекс «Seldon.Basis». Простая (неисключительная) лицензия сроком на {{ license_period }} месяцев.</td>
						<td>шт.</td>
						<td>{{ license_count }}</td>
						<td>{{ license_price }}</td>
						<td>{{ license_total_sum }}</td>
					</tr>
					<tr>
						<td></td>
						<th colspan="4">Итого:</th>
						<th>{{ license_total_sum }}</th>
					</tr>
				</tbody>
			</table>
		</div>
		<div>
			<p>
				<b>Основные функциональные возможности:</b>
				<br><b>Программный комплекс «Seldon.Basis»</b> – программный комплекс, объединяющий программы для ЭВМ и/или базы данных, а также все последующие его обновления и модификации (версии), предназначенные для использования на настольных и карманных персональных компьютерах, мобильных телефонах, коммуникаторах, смартфонах (устройства); позволяющий:
				<br>- оценивать контрагентов (юридические лица и индивидуальные предприниматели) по различным критериям на основе источников открытых данных, в том числе на наличие/отсутствие данных в реестре МСП и РНП, данные о проверках и исполнительных производствах, перечень заключенных контрактов, участие в арбитражных делах, наличие лицензий и товарных знаков, а так же финансовая отчетность.
				<br>- отслеживать последние изменения в деятельности компаний;
				<br>- использовать мультиязычный интерфейс, позволяющий получать информацию на 12-ти языках.
				<br>- визуализировать взаимодействие между выбранными объектами в виде цепочек элементов по заданным критериям («Дерево связей»)
				<br>- использовать справочную скоринговую модель оценки объектов, учитывающую показатели деятельности по различным критериям на основе имеющихся данных («Индекс благонадежности»).
				<br><b>Минимальные технические требования:</b>
				<br>ОС: Семейство Windows, Семейство Unix, Семейство Mac. Браузер: Opera, Firefox, Safari, Chome, Яндекс. Объём программы: 350 Мб. Объём потребляемого Интернет трафика: около 100 Мб в день.
				<br><b>Способы и порядок использования:</b>использование по прямому функциональному назначению на любых устройствах  в пределах количества учетных записей, которое указано в настоящей Спецификации. Функциональное использование осуществляется путем доступа через Сайт размещенный по адресу https://basis.myseldon.com/ с помощью пароля (уникальная последовательность символов, генерируемая программно-аппаратными средствами, и предназначенная для обеспечения возможности использования Программы, а также идентификации пользователя с целью контроля правомерности использования).
				<br><br>
				Лицензиат обязуется передать Сублицензиату в течение 5 (пяти) рабочих дней с момента внесения Сублицензиатом оплаты согласно п. 2.2 настоящего Договора, посредством сетей передачи данных (на электронную почту, указанную в разделе 7) Пароль.
			</p>
		</div>
		<div>
			<table class="table table-bordered">
				<tbody>
					<tr>
						<th>
							<p>
								Лицензиат
								<br>{{ $root.licentiate.short_name }}
							</p>
						</th>
						<th>
							<p>
								Сублицензиат
								<br>{{ $root.sublicentiate.short_name }}
							</p>
						</th>
					</tr>
					<tr>
						<td>
							<p>{{ $root.licentiate.position }}</p>
							<br>_________________/{{ $root.licentiate.director_short }}/
								<br>М.П.
						</td>
						<td>
							<p>{{ $root.sublicentiate.position }}</p>
							<br>_________________/{{ $root.sublicentiate.director_short }}/
								<br>М.П.
						</td>
					</tr>
					<div class="sign_area">
						<div class="sign"></div>
					</div>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	export default {
		props: [
			'index',
			'license_period', 
			'license_count', 
			'license_price', 
			'license_user_count', 
			'license_total_sum'
		],
	}
</script>